/**
 * @fileoverview A function that renders the participant routes.
 *
 * @example
 * renderParticipantRoutes()
 */

import { Navigate, Route } from 'react-router-dom'
import { Layout } from '../components/Layout'
import { ParticipantCard } from '../components/participants/ParticipantCard'
import { ParticipantList } from '../components/participants/ParticipantList'
import { EventsTab } from '../components/participants/tabs/Events'
import { ProfileTab } from '../components/participants/tabs/Profile'
import { TestsTab } from '../components/participants/tabs/Tests'

/**
 * @function renderParticipantRoutes
 * @description Renders the participant routes.
 * @returns {React.ReactNode} - The participant routes.
 */
export function renderParticipantRoutes() {
    return (
        <Route path="participants" element={<Layout />}>
            <Route path=":filter" element={<ParticipantList />} />
            <Route path=":filter/:participantId/*" element={<ParticipantCard />}>
                <Route path="profile" element={<ProfileTab />} />
                <Route path="tests" element={<TestsTab />} />
                <Route path="events" element={<EventsTab />} />
                <Route index element={<Navigate to="profile" replace />} />
            </Route>
            <Route key={'participants-index'} index element={<Navigate to="all" replace />} />
        </Route>
    )
}
